module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/american-logo-6a29a99e8d22df7aa645f78ae1be89d2.svg";